export default "__VITE_ASSET__CeyAt1g5__"